<template>
  <Header />

  <GiftAssign :gift="gift" />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import GiftAssign from "@/components/GiftAssign.vue";

export default {
  name: "GiftView",
  components: {
    Header,
    Footer,
    GiftAssign,
  },
  created() {
    if (!this.$store.state.giftMap.find(item => item.id === this.$route.params.id)) {
      this.$router.push({ name: 'Gifts' })
    }
  },
  data() {
    return {
      gift: this.$store.state.giftMap.find(item => item.id === this.$route.params.id),
    }
  },
};
</script>
